import adsReducer from './slices/ads.slice';
import appReducer from './slices/app.slice';
import categoriesReducer from './slices/categories.slice';
import channelReducer from './slices/channels.slice';
import eventsReducer from './slices/events.slice';
import floatingMenuReducer from './slices/floatingMenu.slice';
import focusReducer from './slices/focus.slice';
import genresReducer from './slices/genres.slice';
import keepWatchingReducer from './slices/keepWatching.slice';
import magicRemoteReducer from './slices/magicRemote.slice';
import mainReducer from './slices/main.slice';
import mediaReducer from './slices/media.slice';
import menuReducer from './slices/menu.slice';
import modalReducer from './slices/modal.slice';
import plansReducer from './slices/plans.slice';
import playerReducer from './slices/player.slice';
import recordingReducer from './slices/recordings.slice';
import routerReducer from './slices/router.slice';
import userReducer from './slices/user.slice';
import { configureStore } from '@reduxjs/toolkit';

export const store = configureStore({
  reducer: {
    ads: adsReducer,
    app: appReducer,
    categories: categoriesReducer,
    channels: channelReducer,
    events: eventsReducer,
    floatingMenu: floatingMenuReducer,
    focus: focusReducer,
    genres: genresReducer,
    keepWatching: keepWatchingReducer,
    magicRemote: magicRemoteReducer,
    main: mainReducer,
    media: mediaReducer,
    menu: menuReducer,
    modal: modalReducer,
    plans: plansReducer,
    player: playerReducer,
    recordings: recordingReducer,
    router: routerReducer,
    user: userReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
